<span class="text-bold">Payment Service</span>
  <div
    class="flex flex-wrap lg:flex-nowrap flex-col lg:flex-row gap-3 col-12 mt-3"
  >
    <ng-container *ngFor="let config of documentConfigs; let i = index">
      <nz-card
        class="col"
        [nzLoading]="loading"
        nzHoverable
      >
        <div class="p-4 rounded bg-white">
          <div class="flex justify-between items-center">
            <h6 class="text-bold">{{ config.title }}</h6>
            <div class="flex gap-1 items-center">
              <div [ngClass]="handleDotStatus(getStateByType(config.type)?.current_state)"></div>
              <span class="text-grey">
                {{ handleStatus(getStateByType(config.type)?.current_state) || ''}}
              </span>
            </div>
          </div>
          <div class="bg-light p-3 rounded border mt-2" [style.min-height]="config.type === 'UAT' ? '230px' : ''">
            <nz-timeline>
              <nz-timeline-item *ngFor="let step of config.timeline"
                [nzColor]="step.key === 'Init' ? (getStateByType(config.type)?.state === 'Init' ? 'red' : 'green') :
                           (step.state! === 5 ? (getStateByType(config.type)?.current_state === 5 ? 'green' : (getStateByType(config.type)?.current_state === 4 || getStateByType(config.type)?.current_state === 6 ? 'red' : 'gray')) :
                           ((getStateByType(config.type)?.current_state ?? 0) >= (step.state! + 1) ? 'green' : (getStateByType(config.type)?.current_state === step.state! ? 'red' : 'gray')))">

                <ng-container *ngIf="step.key === 'Init'">
                  <span [ngClass]="getStateByType(config.type)?.state === 'Init' ? 'text-bold' : ''">
                    {{ step.label }}
                  </span>
                </ng-container>

                <ng-container *ngIf="step.key !== 'Init'">
                  <span *ngIf="getStateByType(config.type)?.current_state !== 6 || step.state! !== 5"
                    [ngClass]="{
                      'text-grey': (getStateByType(config.type)?.current_state ?? 0) < step.state! && (step.state! !== 5 || getStateByType(config.type)?.current_state !== 4),
                      'text-bold': getStateByType(config.type)?.current_state === step.state!
                    }">
                    {{ step.label }}
                  </span>
                  <div class="flex flex-col" *ngIf="getStateByType(config.type)?.current_state === 6 && step.state! === 5">
                    <span class="text-bold">{{ step.declineLabel }}</span>
                    <span class="mt-2 text-bold">Note:</span>
                    <span>{{ getStateByType(config.type)?.notes }}</span>
                  </div>
                </ng-container>
              </nz-timeline-item>
            </nz-timeline>
          </div>

          <ng-container [ngSwitch]="config.type">
            <!-- SLA Actions -->
            <div *ngSwitchCase="'SLA'">
              <button *ngIf="getStateByType(config.type)?.current_state === 1" class="btn btn-primary text-white col-12 mt-2" (click)="handleAction(config, 'create')">Input SLA Data</button>
              <div class="flex gap-3 mt-3" *ngIf="(getStateByType(config.type)?.current_state ?? 0) >= 2">
                <button class="btn text-nowrap" (click)="handleAction(config, 'edit')">Edit SLA</button>
                <div class="flex gap-2">
                  <button class="btn btn-outline-primary text-nowrap" (click)="downloadPdf('SLA')">Download SLA</button>
                  <button class="btn btn-primary text-white text-nowrap" (click)="sendDoc('SLA')">Send SLA</button>
                </div>
              </div>
            </div>

            <!-- CA Actions -->
            <div *ngSwitchCase="'CA'">
              <div class="flex gap-3 mt-2">
                <button *ngIf="(getStateByType(config.type)?.current_state ?? 0) <= 2" class="btn btn-primary text-white col-12 mt-2" (click)="handleAction(config, 'create')">Input CA Data</button>
                <div class="flex gap-3 mt-2" *ngIf="(getStateByType(config.type)?.current_state ?? 0) > 2">
                  <button class="btn text-nowrap" (click)="handleAction(config, 'edit')">Edit CA</button>
                  <div class="flex gap-2">
                    <button class="btn btn-outline-primary text-nowrap" (click)="downloadPdf('CA')">Download CA</button>
                    <button class="btn btn-primary text-white text-nowrap" (click)="sendDoc('CA')">Send CA</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- UAT Actions -->
            <div *ngSwitchCase="'UAT'">
              <button *ngIf="getStateByType(config.type)?.current_state === 1" class="btn btn-primary text-white text-nowrap w-100 mt-3" (click)="handleAction(config, 'create')">Input UAT</button>
              <button *ngIf="getStateByType(config.type)?.current_state !== 1" class="btn btn-outline-primary text-nowrap w-100 mt-3" (click)="handleAction(config, 'edit')">Edit UAT</button>
            </div>
          </ng-container>
        </div>
      </nz-card>
    </ng-container>
  </div>
